module.exports = __webpack_public_path__ + "static/media/service_temp_0.48d1708d.jpg";